import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import SwRoundButton from '@/components/molecules/Buttons/SwRoundButton.vue';
import useUsersFunc from '@/components/utils/UsersUtil';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwPostWorkNavigation',
  setup(__props) {

const userUtil = useUsersFunc();
/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-post-work-navigation': true,
}));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container", _unref(classes)])
  }, [
    (_unref(userUtil).isLoggedIn())
      ? (_openBlock(), _createBlock(SwRoundButton, {
          key: 0,
          class: "sw-post-work-navigation--button",
          icon: "sw-icon-pen",
          color: "rainbow",
          to: "/mypage/works/post",
          label: `作品を
      投稿`
        }))
      : _createCommentVNode("", true),
    (!_unref(userUtil).isLoggedIn())
      ? (_openBlock(), _createBlock(SwRoundButton, {
          key: 1,
          class: "sw-post-work-navigation--button",
          icon: "sw-icon-member",
          color: "rainbow",
          to: "/signup",
          label: `アカウント
      作成`
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})